import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const MobileNavStyle = styled.div`
  display: block;
  display: flex;
  width: 100%;
  background-color: #fff;

  @media only screen and (min-width: ${Variable.tablet}) {
    display: none;
  }

  > button {
    flex: 1;
    text-align: center;
    background: none;
    border: 0;
    padding: 24px 8px;

    &:nth-child(2) {
      flex: 4;
    }

    img {
      display: block;
      margin: 0 auto 12px;
    }
  }

  &.mobile-nav-fixed {
    left: 0;
    right: 0;
    padding-right: 15px;
    padding-left: 15px;
    position: fixed;
    top: 0;
    z-index: 3;
    box-shadow: 0 10px 8px 0px rgb(191 191 191 / 12%);

    @media only screen and (min-width: ${Variable.tablet}) {
      position: static;
      padding-right: 0;
      padding-left: 0;
    }

    ~ .mobile-checkout-summary {
      margin-top: 100px;
    }
  }
`;
